export var CustomPDFReportRequiredNumSecurities;
(function (CustomPDFReportRequiredNumSecurities) {
    CustomPDFReportRequiredNumSecurities[CustomPDFReportRequiredNumSecurities["ONE"] = 1] = "ONE";
    CustomPDFReportRequiredNumSecurities[CustomPDFReportRequiredNumSecurities["TWO"] = 2] = "TWO";
    CustomPDFReportRequiredNumSecurities[CustomPDFReportRequiredNumSecurities["THREE_PLUS"] = 3] = "THREE_PLUS";
})(CustomPDFReportRequiredNumSecurities || (CustomPDFReportRequiredNumSecurities = {}));
